import { createAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import {
  claimLineItemSchema,
  crewOrderSchema,
  gspOrderSchema,
} from '~/utils/schemas';

export const completeCrewClaim = createAction('crewClaim/complete');

const orderPayloadSchema = z.union([crewOrderSchema, gspOrderSchema]);
export const setOrder =
  createAction<z.infer<typeof orderPayloadSchema>>('order/setOrder');

export const invalidateLineItem = createAction<string>(
  'draftClaimLineItem/invalidateLineItem',
);

export const completeDraftClaimLineItem = createAction<
  z.infer<typeof claimLineItemSchema>
>('draftClaimLineItem/completeDraftClaimLineItem');
